import { Bot } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Animated typing indicator shown while assistant is responding.
 * Matches the ChatBubble layout with avatar and bouncing dots.
 */
export function TypingIndicator() {
  return (
    <div className="flex w-full gap-3 animate-in fade-in-0 duration-200">
      {/* Avatar */}
      <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground shadow-sm">
        <Bot className="size-4" />
      </div>

      {/* Typing bubble */}
      <div className="flex items-center gap-1.5 rounded-2xl rounded-tl-md border border-border/50 bg-card px-4 py-3 shadow-sm">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={cn(
              'size-2 rounded-full bg-muted-foreground/50',
              'animate-bounce'
            )}
            style={{
              animationDelay: `${i * 150}ms`,
              animationDuration: '600ms',
            }}
          />
        ))}
      </div>
    </div>
  );
}
